/**
 * Helper to compute per-material and overall PCI values
 * consistent with ISO 59020 & DesignAssessmentPanel formulas.
 */
import { getDefaultDisassemblyFactors } from "../pages/Products/Circularity/pciOptions";

export const computePciData = (combined_data, topic = "Product", id = "default") => {
  const circularities = combined_data?.combined_circularities || [];
  let rowConfigs = {};

  try {
    const saved = localStorage.getItem(`arivu_pci_selections_${topic}_${id || "default"}`);
    if (saved) rowConfigs = JSON.parse(saved);
  } catch (e) {
    console.error("Failed to read PCI configurations from localStorage", e);
  }

  let totalMass = 0;
  let sumPciTimesMass = 0;

  const rows = circularities.map((item, index) => {
    const config = rowConfigs[item.id || item.env_id] || {};
    const defaults = getDefaultDisassemblyFactors(item);
    const ct = Number(config.ct ?? item.ct_factor ?? defaults.ct) || defaults.ct;
    const ca = Number(config.ca ?? item.ca_factor ?? defaults.ca) || defaults.ca;
    const indep = Number(config.indep ?? item.indep_factor ?? defaults.indep) || defaults.indep;
    const gpe = Number(config.gpe ?? item.gpe_factor ?? defaults.gpe) || defaults.gpe;

    // Harmonic mean disassembly potential Fi
    const fi = 4 / ((1 / ct) + (1 / ca) + (1 / indep) + (1 / gpe));

    const mciVal = item.percentage_mci !== undefined
      ? Number(item.percentage_mci)
      : (item.MCI !== undefined
        ? Math.max(0, (Number(item.MCI) - 0.1) / 0.9)
        : (item.row_mci !== undefined ? Math.max(0, (Number(item.row_mci) - 0.1) / 0.9) : 0));

    const pci = mciVal * fi;
    const mass = Number(item.mass) || 0;

    totalMass += mass;
    sumPciTimesMass += pci * mass;

    return {
      ...item,
      ct,
      ca,
      indep,
      gpe,
      fi,
      pci,
      percentage_pci: Math.max(0, parseFloat((pci * 100).toFixed(2))),
      mass,
      label: item.description || `Point ${index + 1}`,
      normalized_gwp: parseFloat(item.normalized_gwp || 0),
    };
  });

  const overallPci = totalMass > 0 ? sumPciTimesMass / totalMass : 0;
  const percentageOverallPci = overallPci * 100;

  const chartData = rows.map((row) => ({
    label: row.description,
    value: sumPciTimesMass > 0 ? (row.pci * row.mass) : 0,
    env_id: row.env_id,
  }));

  return {
    rows,
    chartData,
    overallPci,
    percentageOverallPci,
    totalMass,
  };
};
